import axios from 'axios';

const NGWordApi = {
  create: (values) => {
    return axios.post('ng-words/', values);
  },
  list: (params) => {
    return axios.get('ng-words/', { params });
  },
  batchDelete: (values) => {
    return axios.post(`ng-words/batch-delete/`, values);
  },
}

export default NGWordApi;
